"use client";

import { useState } from 'react'

import logger from '@/lib/logger'
import AppLogo from '../apps/logo'
import SectionMoreButton from '../common/sectionMoreButton';




export default function ConnectionsList({ 
  app={},
  appConnections=[], 
  chunk=5*10, 
  urlType='connection' // You can view it as Connections or Apps
}) {
  logger.info("Component.ConnectionsList rendering.");

  const items = (urlType === 'app') ? appConnections : appConnections?.map(item => item?.app)

  const [page, setPage] = useState(1)  // Using to load more apps
  const itemsVisible = items?.slice(0, page*chunk)


  const url = (item) => {
    if (urlType === 'app') return `/${item?.slug}`
    return `/${app?.slug}/integrations/${item?.slug}`    
  }

  const title = (item) => {
    if (urlType === 'app') return item?.name 
    return `${app?.name} to ${item?.name} integration`    
  }  

  const name = (item) => {
    if (urlType === 'app') return item?.name 
    return `${app?.name} to ${item?.name}`    
  }    


  return (
    <div className="space-y-6">
      
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
        {/* grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 */}
        {itemsVisible?.map((a) => (
          <div
            key={a?.slug}
            className=" rounded border border-gray-300 bg-white hover:border-crisp-600/50"
          >
            <div className="relative flex items-center space-x-1.5 pr-1.5">
              
              <div className="p-2  flex-shrink-0">
                <AppLogo app={a} className='w-12 h-12 rounded text-white' />              
              </div>

              <div className=" flex-1 min-w-0">
                <a href={url(a)} title={title(a)} className="focus:outline-none">
                  <span className="absolute inset-0" aria-hidden="true" />
                  <h3 className="text-sm font-medium text-gray-900 line-clamp-2">
                    {name(a)}
                  </h3>
                </a>
              </div>
            </div>
            

          </div>
        ))}
      </div>
      
      {page*chunk < items?.length && (
        <SectionMoreButton 
          title="Show more"
          onClick={() => setPage(page + 1)}
        />        
      )}
    </div>
  )
}


